module.exports = __webpack_public_path__ + "img/awards_image_20.397c426f.jpg";